import { Control } from "../Controls/Control";
import { FormControlParams, IGenericControl } from "../Controls/ControlInterfaces";
import { IForm } from "./IForm";
import { ValidationManager } from "./ValidationManager";

export interface IFormControl extends IGenericControl {
    ownerForm: IForm;
}

export class IFormControl {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            Reflect.has(instance, "ownerForm") && instance instanceof IGenericControl;
    }
}

export class FormControl extends Control implements IFormControl {
    private _ownerForm: IForm;

    public get ownerForm(): IForm {
        return this._ownerForm;
    }

    /**
     * Nastaveni ownerFormu - tj. Formu na kterem lezi MasterableFrame
     */
    public set ownerForm(ownerForm: IForm) {
        this._ownerForm = ownerForm;
    }

    constructor(params: FormControlParams) {
        super(params);

        this.ownerForm = params.ownerForm;
    }

    protected override _setDefaultTooltip(): void {
        // Prázdná metoda
    }
}

/**
 * Rozhraní pro Framy, kterym vyvolava validaci nadrazeny frame.
 */
export interface IValidatableFrame extends IFormControl {
    /**
     * Komponenta provede svou validaci a podle toho si nastaví svůj stav validnosti (IsValid)
     */
    validate(): Promise<boolean>;

    /**
     * Komponenta provede svou validaci a zobrazí chybové hlášky podle toho si nastaví svůj stav validnosti (IsValid)
     */
    validateAndShowMessage(checkRecommended?: boolean, checkPostponed?: boolean): Promise<boolean>;
}

export class IValidatableFrame {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            typeof instance.validate === "function" &&
            typeof instance.validateAndShowMessage === "function" &&
            instance instanceof IFormControl;
    }
}

/**
 * Řídící komponenta umožňující spouštění validace a zobrazení validačních chyb
 */
export interface IValidationMaster {
    /**
     * Objekt spravující validace
     */
    readonly validationManager: ValidationManager;
    /**
     * Provede validaci vsech potrebnych komponenty na framu
     * @param checkRecommended zda se maji kontrolovat i doporucena pole
     * @param checkPostponedRequired zda se maji kontrolovat i odlozene povinnosti
     * @param validatedUnchanged zda se maji kontrolovat i nezmenene zaznamy, muzu volat validaci ulozeneho objektu z metody
     * @returns true pokud validace probehla v poradku, jinak false
     */
    validate(checkRecommended?: boolean, checkPostponedRequired?: boolean, validatedUnchanged?: boolean): Promise<boolean>;
    /**
     * Provede validaci vsech potrebnych komponenty na framu a zobrazi vysledne zpravy a validacni chyby
     * @returns true pokud validace probehla v poradku, jinak false
     */
    validateAndShowMessage(): Promise<boolean>;
}

export class IValidationMaster {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            Reflect.has(instance, "validationManager") &&
            typeof instance.validate === "function" &&
            typeof instance.validateAndShowMessage === "function";
    }
}
